var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.5L22 20.5L30 13",
    stroke: "#2F2F5B",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 13H30V18",
    stroke: "#2F2F5B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C12 21.9477 12.4477 21.5 13 21.5H15C15.5523 21.5 16 21.9477 16 22.5V30.5H12V22.5Z",
    stroke: "#2F2F5B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.5C20 24.9477 20.4477 24.5 21 24.5H23C23.5523 24.5 24 24.9477 24 25.5V30.5H20V25.5Z",
    stroke: "#2F2F5B",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 21.5C28 20.9477 28.4477 20.5 29 20.5H31C31.5523 20.5 32 20.9477 32 21.5V30.5H28V21.5Z",
    stroke: "#2F2F5B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.906b225e.svg";
export { ForwardRef as ReactComponent };